import registryEndpoints from "./endpoints/registry-endpoints";
import apiConfig from "../config/api";
import http from "./http";
import store from "../store/index";

const {
  getRegistries,
  getReservedNumbers,
  reserveNumbers,
  getRegistryEntries,
  getRegistryStats,
} = registryEndpoints;
const { baseURL } = apiConfig;

const RegistriesService = {
  async getRegistryStats(registryId) {
    const getRegistryStatsUrl = `${baseURL}${getRegistryStats.GET(registryId)}`;
    return await http
      .get(
        getRegistryStatsUrl,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .catch((error) => {
        return error;
      });
  },
  async getRegistryEntries(filters, page = 1, pageSize = 100) {
    const getRegistryEntriesUrl = `${baseURL}${getRegistryEntries.GET()}?page=${page}&pageSize=${pageSize}`;
    http.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${store.state.token}`;

    return await http
      .post(getRegistryEntriesUrl, filters, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .catch((error) => {
        return error;
      });
  },
  async getReservedNumbers(registryId) {
    const getReservedNumbersUrl = `${baseURL}${getReservedNumbers.GET(
      registryId
    )}`;
    return await http
      .get(
        getReservedNumbersUrl,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .catch((error) => {
        return error;
      });
  },
  // Clientul cere doar cantitatea; numerele, anul si data le stabileste serverul.
  async reserveNumbers(registryId, count, username) {
    const reserveNumbersUrl = `${baseURL}${reserveNumbers.GET(registryId)}`;
    return await http
      .post(
        reserveNumbersUrl,
        { count, username },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .catch((error) => {
        return error;
      });
  },

  async getRegistries(page = 1, pageSize = 100) {
    const getAllRegistriessUrl = `${baseURL}${getRegistries.GET()}?page=${page}&pageSize=${pageSize}`;
    http.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${store.state.token}`;

    return await http
      .get(
        getAllRegistriessUrl,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${store.state.token}`,
          },
        }
      )
      .catch((error) => {
        return error;
      });
  },
};

export default RegistriesService;
